<script>
export let components = false;
export let gap = "0em";
export let bottomGap = "0em";
export let topGap = "0em";
export let _gap = `${topGap} 0em ${bottomGap} 0em`;
export let layout = "column"; // row, grid, etc.
export let justifyContent = "flex-start";
export let alignItems = "stretch";  //justify-content
export let alignContent = "flex-start";
export let wrap = false;
export let backgroundColor = "transparent";
export let h = 'auto';
export let w = "auto";
export let margin = "0em";
export let border = "none";
export let bottomBorder = "none";
export let padding = "0em";
export let pointer = false;
export let scroll = 'visible';
export let direction = ""


let style;
$: style = `
--width:${w};
--height:${h};
--justifyContent:${justifyContent};
--alignContent:${alignContent};
--alignItems:${alignItems};
--backgroundColor:${backgroundColor};
--padding:${padding};
--margin:${margin};
--bottomGap:${_gap};
--border:${border};
--bottomBorder:${bottomBorder};
--scroll:${scroll};
--direction:${direction}
`

</script>

<style>
    .container{
        display: flex;
        height : var(--height);
        width : var(--width);
        justify-content : var(--justifyContent);
        align-content : var(--alignContent);
        align-items : var(--alignItems);
        background-color: var(--backgroundColor);
        margin: var(--margin);
        padding: var(--padding);
        border: var(--border);
        border-bottom: var(--bottomBorder);
        overflow: var(--scroll);
        flex-direction: var(--direction);
    }

    /* .container:hover{
        background: var(--hoverBackground);
        color: var(--hoverColor);
    } */

    .row{
        flex-flow: row nowrap;
    }

    .column{
        flex-flow: column nowrap;
    }

    .wrap{
        flex-wrap:wrap!important;
    }

    .container.column > *:not(:last-child){
        /* margin: var(--bottomGap); */
    }

    .container.row > *:not(:first-child){
        margin-left: var(--gap);
    }

    .container > *{
        width : var(--width);
        /* margin: var(--bottomGap); */
    }

    .pointer{
        cursor:pointer;
    }
</style>

<div in class:wrap class="container" class:pointer class:row={layout=="row"} class:column={layout=="column"} {style} on:click>
{#if components}
    {#each components as component}
        <div style="--gap:{gap};--w:{w};">
            <svelte:component this={component.component} {...component.input}></svelte:component>
        </div>
    {/each}
{:else}

    <slot gap={gap}></slot>

{/if}
</div>